import * as React from 'react';
import classNames from 'classnames';

/** Stylesheet Imports */
import styles from './AsyncButton.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

export interface Props {
  loading?: boolean;
  success?: boolean;
  failure?: boolean;
  asyncState?: string;
  className?: string;
  onSubmit?: Function;
  type?: 'button' | 'submit' | 'reset' | undefined;
  danger?: boolean;
  disabled?: boolean;
  secondary?: boolean;
  children?: React.ReactNode;
}

export interface State {
  finished: boolean;
}

export default class AsyncButton extends React.PureComponent<Props, State> {
  timeout: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      finished: false,
    };
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.asyncState === 'REQUEST' || props.loading) {
      return {
        finished: false,
      };
    }

    return state;
  }

  componentDidUpdate() {
    const { success } = this.props;
    if (success) {
      this.timeout = setTimeout(() => {
        this.setState({
          finished: true,
        });
      }, 2000);
    }
  }

  componentWillUnmount(): void {
    clearTimeout(this.timeout);
  }

  handleClick = () => {
    const { onSubmit } = this.props;
    if (onSubmit) {
      onSubmit();
    }
  };

  render() {
    const { className, loading, success, asyncState, type, danger, disabled, secondary } = this.props;
    const { finished } = this.state;
    const buttonClasses = classNames(
      styles.button,
      {
        [styles.secondary]: secondary,
        [styles.loading]: loading || asyncState === 'REQUEST',
        [styles.success]: (success || asyncState === 'SUCCESS') && !finished,
        [styles.danger]: danger,
      },
      className,
    );
    return (
      <button className={buttonClasses} onClick={this.handleClick} type={type} disabled={disabled}>
        <div className={styles.buttonText}>{this.props.children}</div>
        <div className={styles.buttonLoading}>
          <FontAwesomeIcon icon={faSpinnerThird} className="fa-fast-spin" />
        </div>
        <div className={styles.buttonSuccess}>
          <FontAwesomeIcon icon={faCheck} />
          {/* Here for testing purposes */}
          {(success || asyncState === 'SUCCESS') && !finished && <span className="hidden-visibility">Async Success</span>}
        </div>
      </button>
    );
  }
}
